module.exports = __webpack_public_path__ + "img/pic_xiaomisteptwotwo.e37d969e.png";